import styled from '@emotion/styled'
import { Button, Icon } from 'components/patterns'

export const PageHeader = styled.div`
  margin-bottom: 16px;
  padding: 16px 0;
  border-bottom: 1px solid ${(props) => props.theme.navBorderBottomColor};
`

export const PositionCreateFeature = styled.div`
  position: absolute;
  right: 50px;
  top: 63px;
  z-index: 10;
`

export const PreCreateFeatureButton = styled(Button)`
  margin: 0 4px !important;
`

export const ResultsHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & h3 {
    flex: 1;
  }
`

export const CreateIcon = styled(Icon)`
  &&& {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
`

export const FixedLayoutTable = styled.div`
  table {
    table-layout: fixed;
  }
  .ant-table-tbody > tr > td,
  .ant-table-thead > tr > th {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
